module.exports = __webpack_public_path__ + "media/src/images/global-stats-chart-default-7ac90ee808440b93d884d0e4ec65f9a5.png";